import mitt from 'mitt'


/**
 * Event bus for handling client side events.
 * - do not use EventBus on server side to avoid memory leaks
 * - on serverside vue components are not reactive anyway
 * - use `mitt` library instead of vue to stay compatible with vue 3
 *
 * @see https://v3.vuejs.org/guide/migration/events-api.html#_2-x-syntax
 */
const EventBus = (() => {
    if (process.server) {
        return { $on () {}, $off () {}, $emit () {}, $clear () {} }
    }

    // @see https://www.npmjs.com/package/mitt#usage
    const emitter = mitt()

    return {
        $on: (name, cb) => emitter.on(name, cb),
        $off: (name, cb) => emitter.off(name, cb),
        $emit: (name, payload) => emitter.emit(name, payload),
        $clear: () => emitter.all.clear(),
    }
})()

export default EventBus
